import { gql } from '@apollo/client'

import { getMutationService } from '../../../../helpers/GraphqlHelpers'
import { RefreshTokenMutation } from '../../../generated/graphql'

export const refreshToken = getMutationService({
  mutation: gql`
    mutation refreshToken {
      refreshToken
    }
  `,
  transformer: (response: RefreshTokenMutation) => {
    return response.refreshToken
  },
})
